const allBcRoles = ["EAC Fund Accountant", "EAC Corporate Accountant"] as const;

export type BcRole = (typeof allBcRoles)[number];

export const isBcRole = (value: string | null): value is BcRole => allBcRoles.includes(value as BcRole);
